module.exports = __webpack_public_path__ + "img/picaud-draw.0c3304d7.jpg";